export const TRANSACTIONS_HEADERS = {
  TRANSACTIONS_HEADERS_SET_SELECTED: "TRANSACTIONS_HEADERS_SET_SELECTED",
  TRANSACTIONS_HEADERS_CLEAR_SELECTED: "TRANSACTIONS_HEADERS_CLEAR_SELECTED",
};
